import req from '../../api/request'
import type { EventSeriesScope } from '../../features/event/seriesScope'

/**
 * Permanently delete an event.
 *
 * `scope` applies only to a recurring event: 'this' removes the single
 * occurrence, 'following' removes it and everything after it, 'all' removes
 * the whole series. Omitted for a one-off event, so a plain delete sends no
 * query string at all — the endpoint's own default.
 */
export const deleteEvent = async (
  eventId: string,
  scope?: EventSeriesScope
): Promise<void> => {
  await req(`/events/${eventId}`, {
    method: 'DELETE',
    ...(scope ? { query: { scope } } : {}),
  })
}
